import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import API from "../../../context/API";
import type { RootState } from "../../../redux/store";
import { useActiveStoreId } from "../../Stores/hooks/useActiveStoreId";
import { KIOSK_CONFIG_QUERY_KEY } from "./useKioskConfiguration";
import type { ThemeColors } from "../types";

// Store-scoped: writing with a storeId clones the current merchant-wide (or
// default) configuration into a new per-store row on first write.
export const useSaveKioskConfiguration = () => {
  const queryClient = useQueryClient();
  const { role, loginData } = useSelector((state: RootState) => state.auth);
  const storeId = useActiveStoreId();

  return useMutation<void, Error, ThemeColors>({
    mutationFn: async (colors) => {
      const body: Record<string, string | null> = { ...colors };
      if (role === "admin" || role === "super_admin") {
        body.merchantId = loginData?.merchantId || loginData?.id;
      }
      if (storeId) {
        body.storeId = storeId;
      }
      await API.post("/kiosk-configuration", body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...KIOSK_CONFIG_QUERY_KEY] });
    },
  });
};
